import database from '../../model/firebase/firebase';
import { palette } from '../../system/styles/styles';
// eslint-disable-next-line import/no-cycle
import { setApplicants } from './_applications_actions';
import { setPlatform } from './_platform_actions';
import { setSkills } from './_skills_actions';
import { setVacancies } from './_vacancies_actions';

export const initializerTypes = {
  UPDATE_PLATFORM_DATA: 'initializer/UPDATE_DATA',
  LOAD_POSTULATIONS: 'initializer/LOAD_POSTULATIONS',
};

export const updatePlatformData = (data) => ({
  type: initializerTypes.UPDATE_PLATFORM_DATA,
  data,
});

export const changedLoadPostulations = (data) => ({
  type: initializerTypes.LOAD_POSTULATIONS,
  payload: data,
});

// Necesarios para inicializar la APP

export const forceReload = async () => {
  const current = '1.5.2';
  const remote = (await database.collection('API_data').doc('Version').get()).data().version;
  if (current !== remote) {
    window.location.reload(true);
  }
};

export const startSetPlatform = (platformName) => async (dispatch) => {
  const others = (await database.collection(`${platformName}`).doc('data').get()).data();
  document.documentElement.style.setProperty('--button-color', others?.primaryColor || '#0f3f44');
  document.documentElement.style.setProperty('--link-color', others?.primaryColor || '#0f3f44');
  palette.customColor = others?.primaryColor;
  await dispatch(setPlatform({ ...others, primaryColor: others?.primaryColor }));
};

export const newUpdatePlatform = (data) => async (dispatch, getState) => {
  const { platform } = getState();
  await database
    .collection(`${platform.platformName}`)
    .doc('data')
    .update({ ...data });
  const name = Object.keys(data)[0];
  if (name === 'autoAcceptJobs') {
    let currentData = await database.collection('currentPlatforms').doc('data').get();
    currentData = currentData.data();
    await database.collection('Errores').doc('currentPlatforms').set(currentData);
    currentData = Object.values(currentData.platforms).reduce((acc, element) => {
      if (element.platformName === platform.platformName) {
        const data = { ...element };
        data.autoAcceptJobs = !data.autoAcceptJobs;
        acc.push(data);
        return acc;
      }
      acc.push(element);
      return acc;
    }, []);
    await database.collection('currentPlatforms').doc('data').update({
      platforms: currentData,
    });
  }
  dispatch(updatePlatformData(data));
};

export const startSetSkills = () => async (dispatch, getState) => {
  const { platform } = getState();
  const { Privacy, TermsAndConditions } = platform;
  if (!Privacy && !TermsAndConditions) {
    const d = (await database.collection('TermsAndConditions').doc('Text').get()).data();
    dispatch(newUpdatePlatform({ TermsAndConditions: d.Terms, Privacy: d.Privacy }));
  }
  const snapshot = (await database.collection(`UserSkills`).doc('skills').get()).data();
  dispatch(setSkills(snapshot.items));
};

export const startShowApplicants = () => async (dispatch, getState) => {
  // Se obitne nombre de la plataforma
  const { platformName } = getState().platform;
  dispatch(changedLoadPostulations(true));

  const result = await database
    .collection(`${platformName}/data/applicants`)
    .limit(1000)
    .get();

  dispatch(setApplicants(result.docs.map((candidate) =>
    ({
      ...candidate?.data(),
      id: candidate.id,
    }))));
  dispatch(changedLoadPostulations(false));
};

export const startShowVacancies = () => async (dispatch, getState) => {
  const { platform } = getState();
  const { vacancies } = getState();
  if (!vacancies.length) {
    const jobs = (
      await database
        .collection(`${platform.platformName}/data/vacancies`)
        // .where("createdAt",">=", dayjs().subtract(60, 'days').valueOf())
        .orderBy('createdAt', 'desc')
        .get()
    ).docs.map((snapshot) => {
      return snapshot.data();
    });
    dispatch(setVacancies(jobs));
  }
};
